import { IHttpClient } from '~/packages/core';
import { IApiService } from '~/services/interfaces/IApiService';

// For now this is a proxy layer between AI Core and MX API service
export class WebHttpClient implements IHttpClient {
    protected readonly apiService: IApiService;

    constructor(apiService: IApiService) {
        // TODO: MX API service, we need to change this in the future
        this.apiService = apiService;
    }

    request<T>(config: {
        method: 'get' | 'post';
        url: string;
        data?: unknown;
        params?: unknown;
    }): Promise<T> {
        return this.apiService.apiRequest<T>({
            method: config.method,
            url: config.url,
            data: config.data,
            params: config.params
        });
    }
}
